import { asyncRoutes, constantRoutes } from '@/router'
import { indexInfo } from '@/api/home'

/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  if (route.meta && route.meta.roles) {
    return roles.some(role => route.meta.roles.includes(role))
  } else {
    return true
  }
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, roles) {
  const res = []

  routes.forEach(route => {
    const tmp = { ...route }
    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles)
      }
      res.push(tmp)
    }
  })

  return res
}

const state = {
  routes: [],
  addRoutes: [],
}
const mutations = {
  SET_ROUTES: async (state, routes) => {
    state.addRoutes = routes
    let concatRouters = constantRoutes.concat(routes)
    
    
    let channel_id = JSON.parse(localStorage.getItem('CHANNEL_INFO')) ? JSON.parse(localStorage.getItem('CHANNEL_INFO')).channel_id : ''
    // // channel_id = 0 显示云仓  反则不显示
    // if (channel_id != 0) {
    //   concatRouters.map(item => {
    //     if (item.name == 'yuncang') {
    //       item.hidden = true
    //     }
    //     if (item.path == '/worder') {
    //       item.hidden = true
    //     }
    //     if (item.path == '/Selection') {
    //       item.children.map(i => {
    //         if (i.path == 'AddSKU') {
    //           i.hidden = true
    //         }
    //       })
    //     }
    //     if (item.path == '/settings') {
    //       item.children.map(i => {
    //         if (i.path == 'customprice') {
    //           i.hidden = true
    //         }
    //       })
    //     }
    //   })
    // }
    // console.log(73,concatRouters,channel_id)
    if (channel_id == 0) {
      var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
      link.type = 'image/x-inon';
      link.rel = 'icon';
      link.href = '<%= BASE_URL %>icon.ico'
      document.getElementsByTagName('head')[0].appendChild(link);
    } else {
      var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
      link.type = 'image/x-inon';
      link.rel = 'icon';
      link.href = '<%= BASE_URL %>favicon.ico'
      document.getElementsByTagName('head')[0].appendChild(link);
    }

    state.routes = concatRouters
  }
}

const actions = {
  generateRoutes({ commit }, roles) {
    return new Promise(resolve => {
      let accessedRoutes
      if (roles.includes('admin')) {
        accessedRoutes = asyncRoutes || []
      } else {
        accessedRoutes = filterAsyncRoutes(asyncRoutes, roles)
      }
      accessedRoutes.map(item => {

        if (item.children) {
          item.children.map(items=>{
            if(items.name=='regionalpolicy'){
              debugger
              if(localStorage.getItem('a')==1){
                items.hidden = false
              }else{
                items.hidden = true
              }
            }
            if(items.name=='distribution'){//分销
              if(localStorage.getItem('b')==1){
                items.hidden = false
              }else{
                items.hidden = true
              }
            }
            if(items.name=='merchants'){//招商
              if(localStorage.getItem('c')==1){
                items.hidden = false
              }else{
                items.hidden = true
              }
            }
          })  
          }
      })
      console.log(102,accessedRoutes)
      commit('SET_ROUTES', accessedRoutes)
      resolve(accessedRoutes)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
